module.exports = __webpack_public_path__ + "static/media/positiveImpactTitle.18436130.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/positiveImpactTitle.png
// module id = 1295
// module chunks = 0